module.exports = ".callout{padding:0.5rem 1.5rem 0.5rem 0.5rem;opacity:1;visibility:visible;transition:all ease-in-out 0.2s}.callout.hidden{visibility:hidden;opacity:0;padding:0;margin:0}.callout button.close-button{right:0.5rem;line-height:0.7}\n"


//////////////////
// WEBPACK FOOTER
// ./src/common/modules/shared/components/alert-box/AlertBoxComponent.sass
// module id = 34
// module chunks = 0